<template>
    <form ref="form" :action="url" method="post">
        <input v-for="(value, name) in data" type="hidden" :name="name" :value="value">
        <slot></slot>
    </form>
</template>

<script>
export default {
    name: "Pay",
    props: {
        orderId: Number,
        trigger: {type: Boolean, default: false},
    },
    data() {
        return {
            url: undefined,
            data: {},
        }
    },
    watch: {
        orderId() {
            this.loadData();
        }
    },
    methods: {
        loadData() {
            if (this.orderId) {
                api.order.pay.data(this.orderId).then(response => {
                    this.url = response.data.url;
                    this.data = response.data.data;
                    if (this.trigger) {
                        this.$nextTick(() => this.$refs.form.submit());
                    }
                });
            }
        }
    },
    mounted() {
        this.loadData();
    },
}
</script>
